export default {
  WALLBAY: 'WALLBAY',
  OVERFLOW: 'OVERFLOW_TEST',
  BAR: 'BAR',
};
